/**
 * ⑦ 财报 EPS / Revenue 实际 vs 预期。 Figma：94103:23728
 */

import { ChatSignalTag } from "../../StructuredCards/common/ChatSignalTag";
import { cn } from "utils";
import { SignalCardShell } from "./SignalCardShell";
import type { EarningsMetricRow, SignalCardAssetProps } from "./types";

export interface AssetEarningsActualExpectedCardProps extends SignalCardAssetProps {
  metrics: EarningsMetricRow[];
}

const METRIC_LABEL: Record<string, string> = {
  eps: "EPS",
  revenue: "Revenue",
};

const RESULT_TAG_CLASS: Record<
  EarningsMetricRow["result"],
  string | undefined
> = {
  beat: undefined,
  miss: "bg-background_accent2_overlay20 text-content_accent2_primary",
  inline: "bg-background_white_overlay10 text-content_tertiary",
};

export const AssetEarningsActualExpectedCard: React.FC<
  AssetEarningsActualExpectedCardProps
> = ({ metrics, ...asset }) => {
  return (
    <SignalCardShell {...asset}>
      <div className="flex flex-col gap-4">
        {metrics.map((metric) => {
          const label =
            METRIC_LABEL[metric.metricKey.toLowerCase()] ?? metric.metricKey;
          const tagLabel =
            metric.result === "beat"
              ? "Beat"
              : metric.result === "miss"
                ? "Miss"
                : "Inline";

          return (
            <div key={metric.metricKey} className="flex flex-col gap-1">
              <p className="body_s text-content_tertiary">{label}</p>
              <div className="flex items-start justify-between gap-4">
                <div className="flex items-center gap-2">
                  <span className="body_s text-content_tertiary">实际</span>
                  <div className="flex items-center gap-1">
                    <span className="body_medium_xl text-content_primary">
                      {metric.actualValue}
                    </span>
                    {metric.result !== "inline" ? (
                      <ChatSignalTag
                        label={tagLabel}
                        compact
                        className={cn(RESULT_TAG_CLASS[metric.result])}
                      />
                    ) : (
                      <span className="inline-block h-5 w-[30px]" aria-hidden />
                    )}
                  </div>
                </div>
                <div className="flex items-center gap-2">
                  <span className="body_s text-content_tertiary">预期</span>
                  <span className="body_medium_xl text-content_primary">
                    {metric.expectedValue}
                  </span>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </SignalCardShell>
  );
};
